//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
const COLORS = {
  IN_STOCK: 'green',
  UNAVAILABLE: 'red',
  SOON: 'orange',
  MONTH: 'orange',
  WEEK: 'orange',
  LIMITED: 'orange',
  STORE_ONLY: 'black',
  DELETE: 'white',
  default: 'black'
};
export default {
  name: 'ProductStock',
  props: {
    stock: {
      type: Object,

      default() {
        return {};
      }

    },
    showOnlyInStock: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentStock() {
      return this.stock.message || "".concat(this.$t('IN_STOCK'));
    },

    color() {
      return COLORS[this.stock.status] || COLORS.default;
    }

  }
};